import React, { useEffect, useRef, useState } from 'react';
import 'flatpickr/dist/themes/material_blue.css';
import flatpickr from 'flatpickr';
import { generatePostingSummary } from '../../utils/common.utils';

interface IProps {
    days: number[];
    time: string;
    setDays: React.Dispatch<React.SetStateAction<number[]>>;
    setTime: React.Dispatch<React.SetStateAction<string>>;
}

const PublishSchedule = ({ time, days, setDays, setTime }: IProps) => {
    const inputRef = useRef<HTMLInputElement>(null);

    const handleDayClick = (day: number) => {
        setDays((prevDays) => {
            if (prevDays.includes(day)) {
                return prevDays.filter((d) => d !== day);
            } else {
                const newDays = [...prevDays, day];
                return newDays.sort((a, b) => a - b);
            }
        });
    };

    useEffect(() => {
        const picker = flatpickr(inputRef.current!, {
            enableTime: true,
            noCalendar: true,
            dateFormat: 'h:i K',
            defaultDate: time,
            onChange: (selectedDates) => {
                if (selectedDates.length > 0) {
                    const formatted = flatpickr.formatDate(selectedDates[0], 'h:i K');
                    setTime(formatted);
                }
            },
        });

        return () => picker.destroy();
    }, []);

    return (
        <div className="tw-w-[390px] tw-p-6 tw-border-[2px] tw-rounded-md tw-border-gray-250 tw-drop-shadow-[0_2px_4px_-2px_rgba(0,0,0,0.1)] tw-drop-shadow-[0_4px_6px_-1px_rgba(0,0,0,0.1)]">
            <div className="tw-w-full text-center tw-font-semibold tw-text-lg">
                When would you like to post?
            </div>
            <div className="tw-my-12 tw-w-full">
                <div className="tw-mb-6 ">
                    <div className="tw-font-medium tw-text-base tw-mb-2">
                        Select days of the week:
                    </div>
                    <div className="tw-w-full tw-flex tw-items-center tw-justify-between">
                        <div
                            className={`tw-w-[44px] tw-h-[36px] tw-flex tw-items-center tw-justify-center tw-rounded-md tw-text-sm tw-cursor-pointer ${days.indexOf(7) >= 0 ? 'tw-bg-purple-500 tw-text-white' : 'tw-bg-[#F3F4F6]'}`}
                            onClick={() => handleDayClick(7)}
                        >
                            Sun
                        </div>
                        <div
                            className={`tw-w-[44px] tw-h-[36px] tw-flex tw-items-center tw-justify-center tw-rounded-md tw-text-sm tw-cursor-pointer ${days.indexOf(1) >= 0 ? 'tw-bg-purple-500 tw-text-white' : 'tw-bg-[#F3F4F6]'}`}
                            onClick={() => handleDayClick(1)}
                        >
                            Mon
                        </div>
                        <div
                            className={`tw-w-[44px] tw-h-[36px] tw-flex tw-items-center tw-justify-center tw-rounded-md tw-text-sm tw-cursor-pointer ${days.indexOf(2) >= 0 ? 'tw-bg-purple-500 tw-text-white' : 'tw-bg-[#F3F4F6]'}`}
                            onClick={() => handleDayClick(2)}
                        >
                            Tue
                        </div>
                        <div
                            className={`tw-w-[44px] tw-h-[36px] tw-flex tw-items-center tw-justify-center tw-rounded-md tw-text-sm tw-cursor-pointer ${days.indexOf(3) >= 0 ? 'tw-bg-purple-500 tw-text-white' : 'tw-bg-[#F3F4F6]'}`}
                            onClick={() => handleDayClick(3)}
                        >
                            Wed
                        </div>
                        <div
                            className={`tw-w-[44px] tw-h-[36px] tw-flex tw-items-center tw-justify-center tw-rounded-md tw-text-sm tw-cursor-pointer ${days.indexOf(4) >= 0 ? 'tw-bg-purple-500 tw-text-white' : 'tw-bg-[#F3F4F6]'}`}
                            onClick={() => handleDayClick(4)}
                        >
                            Thr
                        </div>
                        <div
                            className={`tw-w-[44px] tw-h-[36px] tw-flex tw-items-center tw-justify-center tw-rounded-md tw-text-sm tw-cursor-pointer ${days.indexOf(5) >= 0 ? 'tw-bg-purple-500 tw-text-white' : 'tw-bg-[#F3F4F6]'}`}
                            onClick={() => handleDayClick(5)}
                        >
                            Fri
                        </div>
                        <div
                            className={`tw-w-[44px] tw-h-[36px] tw-flex tw-items-center tw-justify-center tw-rounded-md tw-text-sm tw-cursor-pointer ${days.indexOf(6) >= 0 ? 'tw-bg-purple-500 tw-text-white' : 'tw-bg-[#F3F4F6]'}`}
                            onClick={() => handleDayClick(6)}
                        >
                            Sat
                        </div>
                    </div>
                </div>
                <div className="tw-w-full tw-flex tw-flex-col tw-items-start">
                    <div className="tw-font-medium tw-text-base tw-mb-2">Select posting time:</div>
                    <div className="input-group">
                        <span className="input-group-text">
                            <i className="ph-bold ph-clock"></i>
                        </span>
                        <input
                            type="text"
                            ref={inputRef}
                            className="form-control"
                            placeholder="Select time"
                            defaultValue={time}
                            readOnly
                        />
                    </div>
                </div>
            </div>
            <div className="tw-w-full tw-rounded-md tw-bg-purple-75 tw-p-3 tw-flex tw-flex-col tw-items-start tw-gap-1">
                <div className="tw-text-purple-500 tw-font-semibold tw-text-sm">
                    Scheduling Summary:
                </div>
                <div className="tw-font-medium tw-text-[#6B7280] tw-text-sm">
                    {generatePostingSummary(days, time)}
                </div>
            </div>
        </div>
    );
};

export default PublishSchedule;
